import { createSlice } from '@reduxjs/toolkit';
import removeDuplicate from '../../../utils/removeDuplicate';
export type frameType = 'lock' | 'screw' | '';
export type frameSize =
  | 'B10(6 Grommets)'
  | 'B16(8 Grommets)'
  | 'B24(10 Grommets)'
  | '';
export interface IConfigurator {
  name: string;
  size: frameSize;
  frame: frameType;
  grommets: Array<any>;
  accessories: Array<any>;
  base64?: string;
}

const initialState: IConfigurator = {
  name: '',
  size: '',
  frame: '',
  grommets: [],
  accessories: [],
};

const configuratorSlice = createSlice({
  name: 'configurator',
  initialState,
  reducers: {
    setName: (state, action) => {
      state.name = action.payload;
    },
    setSize: (state, action) => {
      state.size = action.payload;
    },
    setFrame: (state, action) => {
      state.frame = action.payload;
    },
    addGrommet: (state, action) => {
      const grommets = state.grommets.filter(
        (grommet) => grommet.slot !== action.payload.slot
      );
      grommets.push(action.payload);
      state.grommets = grommets;
    },
    removeGrommet: (state, action) => {
      state.grommets = state.grommets.filter(
        (grommet) => grommet.slot !== action.payload
      );
    },
    resetConfiguration: (state, action) => {
      state.name = action.payload.name;
      state.frame = action.payload.frame;
      state.size = action.payload.size;
      state.grommets = action.payload.grommets;
      state.accessories = action.payload.accessories;
    },
    addConfiguration: (state, action) => {
      state.name = action.payload.name;
      state.frame = action.payload.frame;
      state.size = action.payload.size;
      state.grommets = action.payload.grommets;
    },
    addAccessories: (state, action) => {
      state.accessories = removeDuplicate(action.payload);
    },
    removeAccessories: (state, action) => {
      state.accessories = state.accessories.filter(
        (accessories) => accessories.articleNumber !== action.payload
      );
    },
  },
});

export const {
  setName,
  setSize,
  setFrame,
  addGrommet,
  removeGrommet,
  addConfiguration,
  resetConfiguration,
  addAccessories,
  removeAccessories,
} = configuratorSlice.actions;
export default configuratorSlice.reducer;
